import { VariableItem } from "@/modules/ckeditor/TextEditor";

type Props = {
  value?: string;
  variableId: string;
  variables: VariableItem[];
};

const BFLetterVariable = (props: Props) => {
  if (props.value) {
    return <>{props.value}</>;
  }
  const element = props.variables.find((e) => e.id === props.variableId);
  if (!element) {
    return null;
  }
  return (
    <span className="mention-variable" data-variable-id={element.id}>
      ${element.name}
    </span>
  );
};

export default BFLetterVariable;
